import React, { useCallback, useEffect, useState } from "react";
import SearchBar from "components/SearchBar";
import { useHistory } from "react-router-dom";
import { getUrl } from "@outplayed/riot-assets";
import { useQuery } from "@apollo/client";
import { GET_FEATURED_LIVE_GAMES } from "@ugg/shared/api/graphql/queries";
import NewRegionSelector from "components/Masthead/NewRegionSelector";
import { useGlobal } from "reactn";
import { getRiotAssetsContext } from "@outplayed/riot-assets";
import { Link } from "react-router-dom";
import { getQueueTypeName, QueueTypeN } from "@ugg/shared/utils/queue-type-helpers";
import classNames from "classnames";
import { getProfileOverviewUrl, getProfileLiveGameUrl } from "@ugg/shared/routes/app-routes";
import { capitalizeFirstLetter, convertRomanNumeral } from "lib/general-helper";

const displayRankText = (tier, rank) => {
  if (!tier) {
    return "Unranked";
  }

  switch (tier.toLowerCase()) {
    case "master":
      return "Master";
    case "grandmaster":
      return "Grandmaster";
    case "challenger":
      return "Challenger";
    default:
      return `${capitalizeFirstLetter(tier)} ${convertRomanNumeral(rank)}`;
  }
};

const Player = (props) => {
  const { player, region, reverse } = props;

  const { getChampionName, getChampionImg } = getRiotAssetsContext();

  const { riotUserName, riotTagLine, tier, rank } = player;
  const profileURLLive = getProfileOverviewUrl(region, riotUserName, riotTagLine);

  return (
    <div className={classNames("player", { player__reverse: reverse })}>
      <div className="player-name-container">
        <Link className="player-name" to={profileURLLive}>
          {riotUserName}#{riotTagLine}
        </Link>
        <div className="player-tier">
          <span>{displayRankText(tier, rank)}</span>
        </div>
      </div>
      <div className="champ-image-container">
        <img src={getChampionImg(player.championId)} alt={getChampionName(player.championId)} />
      </div>
    </div>
  );
};

const Game = (props) => {
  const { game, clientRegion } = props;
  let team1 =
    game.gameQueueConfigId === QueueTypeN.ARENA
      ? game.participants.slice(0, Math.floor(game.participants.length / 2))
      : game.participants.filter((player) => player.teamId === 100);
  let team2 =
    game.gameQueueConfigId === QueueTypeN.ARENA
      ? game.participants.slice(Math.floor(game.participants.length / 2), game.participants.length)
      : game.participants.filter((player) => player.teamId === 200);

  return (
    <div className="game">
      <div className="game-header">
        <Link to={getProfileLiveGameUrl(clientRegion, game.participants[0].riotUserName, game.participants[0].riotTagLine)}>
          {getQueueTypeName(game.gameQueueConfigId)}
        </Link>
      </div>
      <div className="game-players">
        <div className="game-players-column">
          {team1.map((player) => (
            <Player key={player.riotUserName + player.riotTagLine} player={player} region={clientRegion} reverse={false} />
          ))}
        </div>
        <div className="game-players-column">
          {team2.map((player) => (
            <Player key={player.riotUserName + player.riotTagLine} player={player} region={clientRegion} reverse={true} />
          ))}
        </div>
      </div>
    </div>
  );
};

const LiveGameSplash = (props) => {
  const history = useHistory();
  const [clientRegion] = useGlobal("clientRegion");
  const [region, setRegionValue] = useState(clientRegion);
  const [showRegions, setShowRegions] = useState(false);
  const [windowBreakpoint] = useGlobal("responsive");

  const isMobile =
    windowBreakpoint === "MOBILE_SMALL" || windowBreakpoint === "MOBILE_MEDIUM" || windowBreakpoint === "MOBILE_LARGE";

  const { loading, data, error, refetch, networkStatus } = useQuery(GET_FEATURED_LIVE_GAMES, {
    variables: {
      regionId: clientRegion,
    },
    fetchPolicy: "network-only",
    notifyOnNetworkStatusChange: true,
    ssr: false,
  });

  const { getFeaturedGames } = data || {};
  const { gameList } = getFeaturedGames || [];

  const [init, setInit] = useState(false);

  useEffect(() => {
    setInit(true);
  }, []);

  if (!init) {
    return null;
  }

  const handleTest = (value) => {
    setRegionValue(value);
  };

  const handleShowRegions = () => {
    setShowRegions(!showRegions);
  };

  return (
    <div className="live-game-splash landing-page-container">
      <div className="landing-header">
        <div className="logo-container">
          <img width={266} height={86} src={getUrl("ugg/logo/ugg-logo.svg")} />
          <div className="live-container">
            <span className="slash">/</span>
            <span>LIVE</span>
            <div className="red-dot"></div>
          </div>
        </div>
        <div className="large-search search-container">
          <SearchBar
            isLanding={true}
            isLandingMobile={isMobile}
            searchDefault={""}
            placeholder={"Search Yourself or a Champion"}
            history={history}
            autoFocus={true}
            searchBarId="landing"
            goToLiveGame={true}
            region={region}
            handleShowRegions={handleShowRegions}
            showRegions={showRegions}
            isLivePage={true}
          />
        </div>
        {showRegions && <NewRegionSelector handleTest={handleTest} isLivePage={true} isMobile={isMobile} />}
      </div>
      <span className="description">
        You can also copy and paste the lobby discussion into the search field if the game has not started yet{" "}
      </span>
      <div className="featured-games-container">
        <span className="header">Featured Games</span>
        <div className="list">
          {gameList?.slice(0, 3).map((game) => (
            <Game key={game.gameId} game={game} clientRegion={clientRegion} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default LiveGameSplash;
